import { render } from "./common_header.vue?vue&type=template&id=495a0369&scoped=true&lang=pug"
import script from "./common_header.vue?vue&type=script&setup=true&lang=js"
export * from "./common_header.vue?vue&type=script&setup=true&lang=js"

import "./common_header.vue?vue&type=style&index=0&id=495a0369&scoped=true&lang=css"

import exportComponent from "../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495a0369"]])

export default __exports__